import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IMilkingParlorZonesResponse } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export const useGetParlorZones = (parlorId: number | null) => {
	const { data, refetch, isError, isLoading } = useQuery<
		IMilkingParlorZonesResponse,
		AxiosError
	>({
		queryKey: ['parlor-zones', parlorId],
		queryFn: async () => {
			const response = await MilkingProcessService.getParlorZones(parlorId!)
			return response
		},
		enabled: parlorId !== null,
		staleTime: 50000,
		retry: 3,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
